import { sanitizeBindable, sanitizeBoolean, sanitizeBoundValue, sanitizeFormattableBindable, sanitizeString } from './helpers';
function sanitizeOptionValue(value) {
  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
    return value;
  }
  return undefined;
}
export function sanitizeOptionButton(el) {
  const value = sanitizeBoundValue(el.value);
  if (!value) return null;
  const label = sanitizeFormattableBindable(el.label, sanitizeString);
  if (!label) return null;
  const optionValue = sanitizeBindable(el.optionValue, sanitizeOptionValue);
  if (optionValue === undefined) return null;
  return {
    type: 'OptionButton',
    value,
    optionValue,
    label,
    required: sanitizeBindable(el.required, sanitizeBoolean),
    disabled: sanitizeBindable(el.disabled, sanitizeBoolean)
  };
}